import React from 'react';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.typography.caption, 
    backgroundColor: theme.palette.background.white,
    padding: theme.spacing(1),
    fontSize:30,
    color:"#3F51B5",
    fontWeight:'bold'
    
  },
}));

const Logo = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <img alt="Logo" src="/static/logo.svg" width="50" {...props} />
      {"Subcontractor"}
    </div>
  );
};

export default Logo;
